import { render, staticRenderFns } from "./AppraisalSupervisorReviews.vue?vue&type=template&id=6a851f1d"
import script from "./AppraisalSupervisorReviews.vue?vue&type=script&lang=js"
export * from "./AppraisalSupervisorReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports